import React, {useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import {useCart} from "../../../services/Cart/cartService";
import {RootState} from "../../../../reducers";
import {getOrderErrors} from "../../../services/Cart/reducer";
import ErrorFormAlertView from "../../../components/Common/ErrorFormAlertView";
import PopupModal from "../../../components/Modal/PopupModal";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

function ErrorOrderModal(props: Props) {
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();
    const cartService = useCart();

    const newOrder = () => {
        setLoading(true);
        cartService.clean();
        setLoading(false);
    }

    const fixOrderAction = async () => {
        setLoading(true);
        try {
            await cartService.fixOrder();
            setLoading(false);
        } catch (err) {
            setLoading(false);
        }
    }

    return <PopupModal
        bodyContent={
            <>
                <p>
                    {t("modules.home_page.field.problem_with_order.description")}
                </p>
                <p>
                    <ErrorFormAlertView errors={props.orderErrors}/>
                </p>
            </>
        }
        title={t("modules.home_page.field.problem_with_order.title")}
        show
        secondaryButton={
            <button
                className={"btn-spinner btn-primary btn w-100" + (loading ? ' loading' : '')}
                disabled={loading} onClick={fixOrderAction}>
                <span className="left spinner-border spinner-border-sm"></span>
                {t("modules.home_page.action.fix_order.title")}
            </button>
        }
        primaryButton={
            <button
                className={"btn-spinner btn btn-danger w-100" + (loading ? ' loading' : '')}
                disabled={loading} onClick={newOrder}>
                <span className="left spinner-border spinner-border-sm"></span>
                {t("modules.home_page.action.create_new_order.title")}
            </button>
        }
    />
}

const mapStateToProps = (state: RootState) => ({
    orderErrors: getOrderErrors(state.cart)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ErrorOrderModal));
